import React, { Component, PropTypes } from 'react';
import { SpinnerButton, Spinner } from 'components';
import BouncedEmailService from 'frilans-finans/bounced-email/bounced-email-service';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

export class UpdateCustomerEmail extends Component {

  static propTypes = {
    params: PropTypes.any
  };

  constructor (props) {
    super(props);

    this.state = {
      email: '',
      companyEmail: '',
      companyName: '',

      errorMessage: false,
      loadingCompanyData: true,
      loading: false,
      successMessage: false,
      validEmail: true
    };

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleGeneralError = this.handleGeneralError.bind(this);
    this.handleGetCompanySuccess = this.handleGetCompanySuccess.bind(this);
    this.handleGetCompanyReject = this.handleGetCompanyReject.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
  }

  componentDidMount () {
    let linkToken = this.props.params.token;

    if (linkToken) {
      BouncedEmailService.getCompanyDataFromToken(linkToken)
      .then((response) => {
        if (response.status === 200) {
          this.handleGetCompanySuccess(response);
        } else {
          this.handleGetCompanyReject();
        }
      })
      .catch(() => this.handleGetCompanyReject());
    } else {
      this.handleGeneralError();
    }
  }

  handleChangeEmail (event) {
    this.setState({ email: event.target.value });
  }

  handleGetCompanySuccess (response) {
    this.setState({
      loadingCompanyData: false,
      companyEmail: response.data.data.email,
      companyName: response.data.data.company_name
    });
  }

  handleGetCompanyReject () {
    this.setState({
      loadingCompanyData: false,
      errorMessage: proxyCounterpart('BOUNCED_EMAIL_COMPANY_ALREADY_UPDATED')
    });
  }

  handleGeneralError () {
    this.setState({
      loading: false,
      loadingCompanyData: false,
      errorMessage: proxyCounterpart('GENERAL_ERROR')
    });
  }

  validateEmail (email) {
    /*eslint-disable */
    var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /*eslint-enable */

    return re.test(email);
  }

  submitForm (e) {
    e.preventDefault();

    if (!this.validateEmail(this.state.email)) {
      this.setState({
        loading: false,
        validEmail: false
      });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: false,
      successMessage: false,
      validEmail: true
    });

    let linkToken = this.props.params.token;

    BouncedEmailService.updateCompanyEmail(linkToken, this.state.email)
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            loading: false,
            errorMessage: false,
            successMessage: proxyCounterpart('BOUNCED_EMAIL_COMPANY_UPDATED')
          });
        } else {
          this.handleGeneralError();
        }
      })
      .catch(() => {
        this.handleGeneralError();
      });
  }

  renderForm () {
    if (!this.state.errorMessage && !this.state.successMessage && !this.state.loadingCompanyData) {
      return (
        <div className='update-email-container'>
          <div className="update-email-header">
            <h3><Translate content="BOUNCED_EMAIL_COMPANY_TITLE" /></h3>
          </div>
          <div className="update-email-body">
            <div className="mb-30">
              <p>
                <span>{proxyCounterpart('BOUNCED_EMAIL_COMPANY_BODY_PART_1')}</span>
                <span className='bold'> {this.state.companyEmail} </span>
                <span><Translate content='BOUNCED_EMAIL_COMPANY_BODY_PART_2' /></span>
                <span className='bold'> {this.state.companyName}.</span>
              </p>
              <p><Translate content='BOUNCED_EMAIL_COMPANY_BODY_PART_3' /></p>
            </div>
            <form action='' method='POST'>
              <div className="mb-15">
                <input
                  type='text'
                  name='email'
                  className='no-margin'
                  placeholder={proxyCounterpart('ENTER_NEW_EMAIL')}
                  value={this.state.email}
                  onChange={this.handleChangeEmail}
                  autoCorrect='off'
                  autoComplete='off'
                />
              </div>
              {this.renderValidEmailError()}
              <div className='update-email-button-wrapper'>
                <SpinnerButton
                  text={proxyCounterpart('SAVE')}
                  loading={this.state.loading}
                  classes='btn'
                  callback={this.submitForm}
                />
              </div>
            </form>
          </div>
        </div>
      );
    }
  }

  renderLoading () {
    if (this.state.loadingCompanyData) {
      return (
        <Spinner />
      );
    }
  }

  renderErrorMessage () {
    if (this.state.errorMessage) {
      return (
        <div className='update-email-message-container update-email-error'>
          <img src={require('images/icons/exclamation-circle.svg')}/>
          {this.state.errorMessage}
        </div>
      );
    }
  }

  renderSuccessMessage () {
    if (this.state.successMessage) {
      return (
        <div className="update-email-message-container">
          <img src={require('images/icons/0858-checkmark-circle.svg')}/>
          {this.state.successMessage}
        </div>
      );
    }
  }

  renderValidEmailError () {
    if (!this.state.validEmail) {
      return (
        <p><Translate content='EMAIL_INVALID_ERROR' className="error"/></p>
      );
    }
  }

  render () {
    return (
      <div className='bounced-email-page-container'>
        {this.renderLoading()}
        {this.renderForm()}
        {this.renderErrorMessage()}
        {this.renderSuccessMessage()}
      </div>
    );
  }
}

export default (UpdateCustomerEmail);



/** WEBPACK FOOTER **
 ** ./src/views/bounced-email/update-customer-email.js
 **/